import { today } from '../date/index.ts';
import type { TasApplicationExtension as TasApplication } from 'tio-data/data/resources/tas-application.ext';

const COURSE_CASH = 'TAS.AssistanceManner.COURSE_CASH';

// Approving courses funds the card at once, so in these states the request still counts
// against whichever benefit year the approval lands in.
const AWAITING_COURSES_APPROVAL = new Set([
  'TAS.ApplicationState.DEFINE_COURSES',
  'TAS.ApplicationState.PENDING_COURSES_APPROVAL',
]);

/**
 * The as-of date a limits-status request for an application should carry, as a local
 * `YYYY-MM-DD` string, or `undefined` to let the API date the request itself.
 *
 * Left to itself the API dates a request from the program's limit basis: course start,
 * course end, or an estimated paid date of course end plus ESTIMATED_DAYS_TO_PAID. For
 * courses ending late in the year that estimate falls in next year's benefit window, but a
 * CourseCa$h card is funded the moment courses are approved, so the money comes out of the
 * year the approval happens in. A CourseCa$h application still awaiting courses approval is
 * therefore evaluated as of today. Every other application, and CourseCa$h once its courses
 * are approved, keeps the API basis.
 *
 * @param options.paymentMethod - Overrides the payment method persisted on the application;
 *   the guided wizard edits a tracked copy of the fields, so the record can lag the selection.
 */
export function limitsEvaluationDate(
  application: Pick<TasApplication, 'state' | 'paymentMethod'>,
  options: { paymentMethod?: TasApplication['paymentMethod'] } = {}
): string | undefined {
  const paymentMethod = options.paymentMethod ?? application.paymentMethod;
  if (paymentMethod !== COURSE_CASH || !AWAITING_COURSES_APPROVAL.has(application.state)) {
    return undefined;
  }
  return today();
}
